import { Injectable } from '@angular/core';
import { NegativeBarChartParam } from './negative-bar-interface';
import * as _ from 'lodash';
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import * as datazoom from '../../config/datazoom';
import * as textStyle from '../../config/textStyle';
import { CommonService } from '../../service/common.service';
import { axisLabelRotate } from './negative-bar.component'
import { ECharts } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class NegativeBarService {

  constructor(
    private commonService: CommonService
  ) { }

  // getOptionOfNegativeBarChart = (negativeBarChartParam: NegativeBarChartParam, showMenu: boolean): any => {
  //   const style = this.commonService.changeFontSize();
  //   style.interval.right = "110";

  //   const toolboxType = this.getToolboxType(showMenu)

  //   let negativeBarChartOption = {
  //     color: color.defaultColors,
  //     backgroundColor: backgroundColor.backgroundColor,
  //     // grid: negativeBarChartParam.customGrid,
  //     grid: style.interval,
  //     legend: legend.getLegendRightScroll(this.commonService.changeFontSize()),
  //     tooltip: tooltip.getToolTipOfItemChartTranslation(style, negativeBarChartParam.unit, negativeBarChartParam.translationNumber),
  //     toolbox: toolboxType,
  //     xAxis: xAxis.getXaxisOfCategoryNoXDatas(negativeBarChartParam.xAxisName),
  //     yAxis: yAxis.getYaxisOfValueTranlation(style, negativeBarChartParam.yAxisName, negativeBarChartParam.yNameGap, negativeBarChartParam.translationNumber),
  //     series: series.getNegativeBarChartSeries(negativeBarChartParam.datas, negativeBarChartParam.seriesNames, negativeBarChartParam.translationNumber),
  //   }
  //   return negativeBarChartOption;
  // }
  style = this.commonService.changeFontSize();

  // 获取默认配置
  getDefaultOptionOfNegativeBarChart = () => {
    const style = this.commonService.changeFontSize();


    let negativeBarChartOption = {
      color: color.defaultColors,
      backgroundColor: backgroundColor.backgroundColor,
      grid: style.rightLegendGrid,
      legend: legend.getLegendRightScroll(style),
      tooltip: tooltip.getToolTipOfItemChartTranslation(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      xAxis: xAxis.getXaxisOfCategoryNoXDatas(style),
      yAxis: yAxis.getYaxisOfValueTranlation(style),
      series: series.getNegativeBarChartSeriesDefault(),
      textStyle: textStyle.getTextStyle()
    }
    return negativeBarChartOption;
  }

  // 更改图例legend是否显示
  changeLegendShow(options, bcacShowLegend: boolean) {
    options.legend.show = bcacShowLegend;
  }
  // 更改toolbox是否显示
  changeToolboxShow(options, bcacShowToolbox: boolean) {
    // options.toolbox.show = bcacShowToolbox;
  }

  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }
  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string) {
    chartOpt.yAxis[0].name = yAxisName;
  }
  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number) {
    chartOpt.yAxis[0].nameGap = yAxisNameGap;
  }
  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }
  // y轴label的选装
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
    chartOpt.yAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  // 更改图标数据
  changeChartData(options, bcacChartData: NegativeBarChartParam, tooltipUnit: string = '') {
    let style = this.commonService.changeFontSize();
    let translationNumber = (_.isNumber(bcacChartData.translationNumber) && !_.isNaN(bcacChartData.translationNumber) && !_.isUndefined(bcacChartData.translationNumber)) ? bcacChartData.translationNumber : 0;

    options.yAxis[0].axisLabel.formatter = (params) => { return params + translationNumber }
    options.series = series.getNegativeBarChartSeries(bcacChartData.datas, bcacChartData.seriesNames, translationNumber);

    options.tooltip = tooltip.getToolTipOfItemChartTranslation(style, tooltipUnit, translationNumber)
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  setLegendPosition(chartOpt: any, legendPosition: string) {
    switch (legendPosition) {
      case 'none':
        chartOpt.legend = legend.getLegendNotShow(this.style)
        chartOpt.grid = this.style.withoutLegendGrid;
        break;
      case 'top':
        chartOpt.legend = legend.getLegendNotShow(this.style)
        chartOpt.grid = this.style.interval
        break;
      case 'bottom':
        chartOpt.legend = legend.getLegendBottomScroll(this.style)
        chartOpt.grid = this.style.interval
        break;
      case 'right':
        chartOpt.legend = legend.getLegendRightScroll(this.style)
        chartOpt.grid = this.style.rightLegendGrid
        break;
    }
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

}
